function updateSubMenus(menus) {
  if (window.innerWidth >= 960) {
    menus.forEach((menu) =>
      menu.children[0].style.paddingLeft = `${menu.previousSibling.offsetLeft}px`
    );
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const submenus = document.querySelectorAll('.meganav[data-meganav-type="compact_meganav"]');
  updateSubMenus(submenus);
  window.addEventListener('resize', () =>
    updateSubMenus(submenus)
  );
});
